import { useCallback } from 'react';

const useAutoFocus = ({ tag = '', focusOnLoad = true } = {}) => {
    const ref = useCallback((current) => {
        if (!current || !focusOnLoad) {
            return;
        }
        const element = tag ? current.querySelector(tag) : current;
        if (element) {
            setTimeout(() => {
                element.focus();
            }, 1);
        }
    }, []);
    return ref;
};

export { useAutoFocus as default };
//# sourceMappingURL=useAutoFocus.js.map
